import { appConfig } from '@common-config/app.config';
import type { TrialUpgradePromptResponse } from '@extension/wa-communication-layer/api/api-calls';

/** The existing checkout page (plan picker + hosted checkout). The popup never builds its own flow (#1228/#1229). */
export function trialUpgradeCheckoutUrl(plan: 'pro' | 'basic'): string {
  return `${appConfig.PRICING_PAGE}/account-subscription?plan=${plan}`;
}

/** True only when the server returned a complete, shown popup. */
export function shouldShowTrialUpgradePrompt(res: TrialUpgradePromptResponse | null | undefined): res is TrialUpgradePromptResponse & {
  type: NonNullable<TrialUpgradePromptResponse['type']>;
  plan: NonNullable<TrialUpgradePromptResponse['plan']>;
  copy: NonNullable<TrialUpgradePromptResponse['copy']>;
} {
  return !!res && res.show === true && res.type !== null && res.plan !== null && res.copy !== null;
}
